import styled from 'styled-components';
import { colors } from 'globalStyles';
import { media } from 'utils/style-utils';
export const Wrapper = styled.div`
  width: 500px;
  margin: 0 auto;
  ${ media.mobile_500`
    width: 100%;
    padding: 0 20px;
  `}
`;

export const Container = styled.div``;

export const Heading = styled.div`
  padding: ${({ email }) => email ? '44px 0 0 0' : '0 20px 34px'};
`;

export const ButtonGroup = styled.div`
  padding-top: 80px;
  text-align: center;

  > button {
    padding: 10px 32px;
  }
`;

export const StyledForm = styled.form`
  margin-bottom: 50px;
`;

export const ButtonWrapper = styled.div`
  text-align: right;
  padding: 0 20px 30px;
`;

export const PassowordButton = styled.button`
  position: absolute;
  margin: -14px -147px;
  font-size: 10px;
  line-height: 14px;
  color: ${colors.MEDIUM_GRAY};
`;

export const CheckboxLabel = styled.div`
  > a,
  > a:hover {
    text-decoration: underline;
  }
`;

export const FormButtonGroup = styled.div`
  text-align: center;
  padding-top: 30px;

  > button {
    padding: 10px 50px;
    background: linear-gradient(135deg, #00B2FF 0%, #007AFF 100%);

    &:hover,
    &:active {
      background: #fff;
      border: 1px solid #007AFF;
      color: #007AFF;
    }
  }
`;

export const ContactUs = styled.div`
  position: absolute;
  height: 38px;
  bottom: 0px;
  background-color: ${colors.WHITE};
  font-size: 12px;
  padding: 0 20px;

  > a,
  > a:hover {
    color: ${colors.MAIN_COLOR};
  }
`;
export const ColMd6 = styled.div`
  width: 50%;
  float: left;
  padding: 0 15px;
  ${ media.mobile`
    width: 100%;
  `}
`;
export const ColMd6L = styled.div`
  width: 50%;
  float: left;
  padding: 0 15px;
  text-align: left;
  color: #36474F;
  font-family: neue-haas-unica, sans-serif;
  font-size: 16px;
  line-height: 18px;
`;
export const ColMd6R = styled.div`
  width: 50%;
  float: right;
  padding: 0 15px;
  text-align: right;
`;
export const Row = styled.div`
  margin: 0 -15px;
  &after {
    display: block;
    clear: both;
    content: '';
  }
`;
export const ColMd12 = styled.div`
  padding: 0 15px;
  float: left;
  width: 100%;
  > div {
    display: block;
    width: 100%;
    border: 1px solid #B9C3C8;
    border-radius: 3px;
    font-size: 12px;
    line-height: 18px;
    color: #36474F;
    font-weight: 300;
    padding: 0 20px;
    font-family: neue-haas-unica, sans-serif;
    height: 48px;
    padding: 13px;
    margin: 0 0 12px;
  }
`;
export const PriceDetails = styled.div`
  color: #36474F;
  font-size: 16px;
  line-height: 18px;
  float: left;
  width: 100%;
  padding: 0 20px 51px;
  margin: 0 0 43px;
  border-bottom: 1.5px solid #36474F;

  h2 {
    color: #36474F;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    margin: 0 0 32px;
  }

  > strong {
    font-weight: bold;
    text-align: right;
    float: right;
  }
`;


export const Autofill = styled.div`
  color: #36474F;
  font-size: 12px;
  line-height: 18px;
  float: left;
  width: 100%;
  margin: 0 0 17px;
  padding: 0 0 15px;
  border-bottom: 1px solid #E7E9EA;

 > p {
  width: 100%;
  max-width: 40rem;
  margin: 0 auto;
  color: #000;
  padding-right: 4rem;
  margin-bottom: .6rem;
  position: relative;
  background: #fff;

  &:before {
    content: '';
    position: absolute;
    bottom: .4rem;
    width: 100%;
    height: 0;
    line-height: 0;
    border-bottom: 2px dotted #ddd;
  }

  > span {
    display: inline;
    position: relative;
    z-index: 1;
    padding-right: .2rem;
    background: inherit;
  }

  > strong {
    background: inherit;
    position: absolute;
    min-width: 2rem;
    bottom: 0;
    right: 0;
    padding-left: .2rem;
    text-align: right;
    z-index: 2;
    background: inherit;
  }
`;
export const AutofillActive = styled.div`

 > p {
  width: 100%;
  max-width: 40rem;
  margin: 0 auto;
  color: #00C643;
  padding-right: 4rem;
  margin-bottom: .6rem;
  position: relative;
  background: #fff;

  &:before {
    content: '';
    position: absolute;
    bottom: .4rem;
    width: 100%;
    height: 0;
    line-height: 0;
    border-bottom: 2px dotted #00C643;
  }

  > span {
    display: inline;
    background: inherit;
    position: relative;
    z-index: 1;
    padding-right: .2rem;
  }

  > strong {
    background: inherit;
    position: absolute;
    min-width: 2rem;
    bottom: 0;
    right: 0;
    padding-left: .2rem;
    text-align: right;
    z-index: 2;
  }

`;
export const FormHeading =  styled.div `
  float: left;
  width: 100%;
  margin: 0 0 17px;
  color: ${colors.BODY};
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  padding: 0 20px;

  > span {
    float: right;
    padding-top: 5px;
    > em {
      line-height: 38px;
      display: inline-block;
      vertical-align: top;
      text-align: right;
      color: #36474F;
      font-size: 10px;
      line-height: 14px;
      font-weight: normal;
      font-style: normal;
      margin-right: -4px;
    }
    > svg {
      display: inline-block;
      vertical-align: top;
    }
    > a {
      font-size: 18px;
      line-height: 21px;
      font-weight: 600;
    }
  }


`;



// WEBPACK FOOTER //
// ./src/containers/NiceChoice/styledComponents.js